import type { RouteLocationNormalizedGeneric } from 'vue-router';

import { currentUserStore } from '@/stores/currentUser';

import { ENTITY_ROUTES } from './routes.constants';

export const generalGuard = (to: RouteLocationNormalizedGeneric, condition: boolean) => {
  if (condition) {
    return true;
  } else {
    return {
      name: 'Not Found',
      params: { pathMatch: to.path.substring(1).split('/') },
      query: to.query,
      hash: to.hash,
    };
  }
};

export const hardwareTypeGuard = (to: RouteLocationNormalizedGeneric) => {
  return generalGuard(
    to,
    Object.values(ENTITY_ROUTES).includes(to.params?.hardware as ENTITY_ROUTES),
  );
};

export const manageSimTypeGuard = (to: RouteLocationNormalizedGeneric) => {
  return generalGuard(
    to,
    [ENTITY_ROUTES.ROUTER, ENTITY_ROUTES.HYBRID].includes(to.params?.hardware as ENTITY_ROUTES),
  );
};

export const superAdminGuard = (to: RouteLocationNormalizedGeneric) => {
  const currentUser = currentUserStore();
  return generalGuard(to, currentUser.isSuperAdmin);
};

export const superOrOrgAdminGuard = (to: RouteLocationNormalizedGeneric) => {
  const currentUser = currentUserStore();
  return generalGuard(to, currentUser.isSuperOrOrgAdmin);
};

export const anyAdminGuard = (to: RouteLocationNormalizedGeneric) => {
  const currentUser = currentUserStore();
  return generalGuard(to, !currentUser.isUser);
};
